import { db } from '../../config/firebase'

const getDoc = ({ path, docId, docIdName = null }) =>
  db
    .collection(path)
    .doc(docId)
    .get()
    .then((doc) => {
      if (doc.exists) {
        return {
          ...(docIdName ? { [docIdName]: doc.id } : {}),
          ...doc.data(),
        }
      }
      return null
    })
    .catch((error) => {
      console.warn(`Failed to load document ${path}/${docId}`, error)
      return null
    })

export default getDoc
